import api from './api';

export interface Microchip {
  id: number;
  number: string;
  manufacturer?: string;
  implant_date?: string;
  implant_location?: string;
  veterinarian_name?: string;
  veterinarian_crmv?: string;
}

export interface Responsible {
  id: number;
  cpf: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  state?: string;
  zip_code?: string;
}

export interface Animal {
  id: number;
  name: string;
  species: string;
  breed?: string;
  gender?: string;
  birth_date?: string;
  color?: string;
  description?: string;
  photo_url?: string;
  microchip_id: number;
  microchip?: Microchip;
  responsible_id: number;
  responsible?: Responsible;
  owner_id: number;
  status: 'vivo' | 'falecido';
  /** Se o usuário pode editar, informar falecimento e reportar desaparecimento (apenas dono/responsável) */
  can_edit?: boolean;
}

export interface CreateAnimalData {
  name: string;
  species: string;
  breed?: string;
  gender?: string;
  birth_date?: string;
  color?: string;
  description?: string;
  photo_url?: string;
  microchip_number: string;
  responsible_cpf?: string;
  /** Obrigatório quando o CPF do responsável ainda não está cadastrado (ex.: clínica cadastrando para novo dono) */
  responsible_name?: string;
  responsible_email?: string;
  responsible_phone?: string;
  manufacturer?: string;
  implant_date?: string;
  implant_location?: string;
  veterinarian_name?: string;
  veterinarian_crmv?: string;
}

export const animalService = {
  async getAnimals(): Promise<Animal[]> {
    const response = await api.get('/animals');
    return response.data;
  },

  async getAnimal(id: number): Promise<Animal> {
    const response = await api.get(`/animals/${id}`);
    return response.data;
  },

  async createAnimal(data: CreateAnimalData): Promise<Animal> {
    const response = await api.post('/animals', data);
    return response.data;
  },

  async updateAnimal(id: number, data: Partial<CreateAnimalData> & { status?: 'vivo' | 'falecido' }): Promise<Animal> {
    const response = await api.put(`/animals/${id}`, data);
    return response.data;
  },

  async markDeceased(id: number): Promise<Animal> {
    const response = await api.post(`/animals/${id}/deceased`);
    return response.data.animal;
  },

  async getDeceasedAnimals(): Promise<Animal[]> {
    const response = await api.get('/animals/deceased');
    return response.data;
  },

  async searchByCPF(cpf: string): Promise<Animal[]> {
    const response = await api.get('/animals/search', { params: { cpf } });
    return response.data;
  },

  async searchByMicrochip(microchipNumber: string): Promise<Animal[]> {
    const response = await api.get('/animals/search', { params: { microchip_number: microchipNumber } });
    return response.data;
  },

  async search(cpf?: string, microchipNumber?: string): Promise<Animal[]> {
    const params: any = {};
    if (cpf) params.cpf = cpf;
    if (microchipNumber) params.microchip_number = microchipNumber;
    const response = await api.get('/animals/search', { params });
    return response.data;
  },
};
